module.exports = __webpack_public_path__ + "img/australia-ovarian-cancer-female.4320d296.png";